import Bedrock from '../scenarios/bedrock';
import NewHaven from '../scenarios/newhaven';
import HillValley from '../scenarios/hillvalley';
import PortFraser from '../scenarios/portfraser';
import HollandMarsh from '../scenarios/hollandmarsh';
import Mayberry from '../scenarios/mayberry';

import BedrockFrench from '../scenarios/bedrock_fr';
import NewHavenFrench from '../scenarios/newhaven_fr';
import HillValleyFrench from '../scenarios/hillvalley_fr';
import PortFraserFrench from '../scenarios/portfraser_fr';
import HollandMarshFrench from '../scenarios/hollandmarsh_fr';
import MayberryFrench from '../scenarios/mayberry_fr';

import Impact from './Impact';

const ScenarioList = [
  { name: "Bedrock", path: "bedrock", data: {'en': Bedrock, 'fr': BedrockFrench}, startingScore: new Impact(200, 5, 5) },
  { name: "Port Fraser", path: "portfraser", data: {'en': PortFraser, 'fr': PortFraserFrench}, startingScore: new Impact(200, 5, 5)  },
  { name: "Hill Valley", path: "hillvalley", data: {'en': HillValley, 'fr': HillValleyFrench}, startingScore: new Impact(200, 8, 8)  },
  { name: "New Haven", path: "newhaven", data: {'en': NewHaven, 'fr': NewHavenFrench}, startingScore: new Impact(200, 8, 8)  },
  { name: "Holland Marsh", path: "hollandmarsh", data: {'en': HollandMarsh, 'fr': HollandMarshFrench}, startingScore: new Impact(200, 12, 12)  },
  { name: "Mayberry", path: "mayberry", data: {'en': Mayberry, 'fr': MayberryFrench}, startingScore: new Impact(200, 12, 12)  }
]

export default ScenarioList;



// WEBPACK FOOTER //
// ./src/models/ScenarioList.js